import { useContext, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import "./Tour_Details_Tabs.css";

import Itinerary from "./itinerary/Itinerary";
import Price from "./price/Price";
import Permit from "./permit/Permit";
import { Context } from "../../../../../utils/context";
import Image_Modal from "../../../../image-modal/Image_Modal";
import parse from "html-react-parser"

const Tour_Details_Tabs = ({ result }) => {
  const {
    IMG_URL,
  } = useContext(Context);
  const [activeTab, setActiveTab] = useState("overview");

  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleShow = (image) => {
    setSelectedImage(IMG_URL + image?.image);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };
  console.log({ selectedImage });


  const tabs = result?.package_details
    ?.filter(pkg => pkg.package_summernotes?.length) // remove empty ones
    .map((pkg) => ({
      id: pkg.package_detail_type?.name?.toLowerCase().replace(/\s+/g, "_"),

      label: pkg.package_detail_type?.name,

      component: (
        <>
          {pkg.package_summernotes.map((note, i) => (
            <div className="content_box" key={i}>

              {/* Description */}
              <div
                className="content_text"
                dangerouslySetInnerHTML={{ __html: note.descriptions }}
              />

              {/* Images */}
              {note.summernote_images?.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mt-3" >
                  {note.summernote_images.map((img, index) =>
                    img.image ? (

                      < img
                        key={index}
                        src={IMG_URL + img.image}
                        alt="img"
                        style={{ width: "120px", borderRadius: "8px" }}
                        onClick={() => handleShow(img)}
                      />

                    ) : null
                  )}
                </div>
              )}
            </div>
          ))
          }
        </>
      ),
    })) || [];

  return (
    <section className="tour_details_tabs">
      <div className="container">

        {/* Header */}
        <h4 className="tabs_header text-center mb-4">
          Tour Details
        </h4>

        <div className="tab_content_holder">

          <Tab.Container
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
          >

            {/* Horizontal Scroll Tabs */}
            <div className="tabs_scroll_container">
              <Nav className="tabs_wrapper">

                {tabs.map((tab) => (
                  <Nav.Item key={tab.id} className="tabs_item">

                    <Nav.Link
                      eventKey={tab.id}
                      className="tab_btn"
                      onClick={(e) => {
                        setActiveTab(tab.id);

                        e.target.scrollIntoView({
                          behavior: "smooth",
                          inline: "center",
                          block: "nearest",
                        });
                      }}
                    >
                      {tab.label}
                    </Nav.Link>

                  </Nav.Item>
                ))}

              </Nav>
            </div>

            {/* Tab Content */}
            <Tab.Content>

              {tabs.map((tab) => (
                <Tab.Pane key={tab.id} eventKey={tab.id}>
                  {tab.component}
                </Tab.Pane>
              ))}

            </Tab.Content>

          </Tab.Container>

        </div>

      </div>

      <Image_Modal
        show={showModal}
        handleClose={handleClose}
        image={selectedImage}
      />
    </section>
  );
};

export default Tour_Details_Tabs;